var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"icon",attrs:{"tabindex":"-1","focusable":"false"}},[_c('use',_vm._b({},'use',{ 'xlink:href': _vm.symbolName },false))])
}
var staticRenderFns = []

export { render, staticRenderFns }